export default {"src":"/_next/static/media/reset-s--color-primary.c2b739c7.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};